// extracted by mini-css-extract-plugin
export default {"main":"PDFBlock_main__rxJp+","page":"PDFBlock_page__jeS0k","section":"PDFBlock_section__0wZ0g"};